import * as React from 'react';
// eslint-disable-next-line import/no-duplicates
import ImpressionsHandler from '@nykaa/deals-utils/impressions';
// eslint-disable-next-line import/no-duplicates
import ClickHandler from '@nykaa/deals-utils/clicks';
import { handleRightClickCallback } from '../../helper';
import IoElement from '../IOElement';
const TextOnly = (widgetData) => {
    const { params, isServer, trackingData, isDesktop, isDevModeEnabled, devModeData, } = widgetData;
    const { appLinkData, appLinkType, title, trackingParams, webActionUrl, webActionType, } = params;
    const handleIntersect = () => {
        ImpressionsHandler.handleImpression(trackingData);
    };
    const handleIntersectV2 = () => {
        ImpressionsHandler.handleImpressionV2(trackingData);
    };
    const exitCallBackHandler = () => {
        ImpressionsHandler.removeImpression(trackingData);
    };
    const clickHandler = (event) => {
        event.preventDefault();
        ImpressionsHandler.handleClick(trackingData)
            .finally(() => {
            /**
                 * ? Why finally?
                 * even in case of an error in handling impression...
                 * we would want the click to function as expected
                 */
            ClickHandler.handleClick({
                appLinkData,
                appLinkType,
                trackingParams,
                webActionType,
                webActionUrl,
                isDesktop,
            });
        });
    };
    const devModeHandler = (!!isDevModeEnabled && {
        onContextMenu: () => handleRightClickCallback(devModeData),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(IoElement, { isServer: isServer, onIntersect: handleIntersect, exitCallBack: exitCallBackHandler, onIntersectV2: handleIntersectV2 },
            React.createElement("div", Object.assign({ onClick: clickHandler, className: "textonlybtn" }, devModeHandler), title))));
};
export default TextOnly;
